
import { Navigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { userLogout } from "Redux/Actions";

const OnlyForLoggedOut = ({ user, element }) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);

  const redirectURL = searchParams.get("redirectURL");

  useEffect(() => {
    const tokenExpired = searchParams.get("token_expired");
    if (tokenExpired === "true") {
      dispatch(userLogout());
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  if (isLoading) {
    return null;
  }

  // Only redirect to lists if user is present AND isAuthenticated is true
  if (user && isAuthenticated) {
    if (redirectURL) {
      return <Navigate to={redirectURL} replace />;
    }
    return <Navigate to="/lists" replace />;
  }
  return element;
};

export default OnlyForLoggedOut;
